<c-card *transloco="let t">
    <c-card-body>
            <c-row>
              <c-col md="6">
                  <h1>{{ t('Start/End Shift Upload and Export') }}</h1>
              </c-col>
              <c-col md="6">
                <span class="text-end mb-2">
                    <a href="https://okalone.zendesk.com/hc/en-gb/articles/35908284843793-Upload-Export-Shift-Start-and-End-Times" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a> <br/>
                </span>
                <div *ngIf="okService.settings.international" class="alert alert-warning">
                    <i class="fa-solid fa-circle-info"></i> {{ t("Times on the upload/export files Start/End Times apply to the worker's local timezone") }}
                </div>
              </c-col>
            </c-row>

            <div class="row">
                <div class="col-12 col-md-6">

                    <div class="card">
                        <div class="card-header">
                            <i class="fa-solid fa-upload"></i> {{ t('Upload Start and End Shifts') }}
                        </div>
                        <div class="card-body">
                            <p>{{ t('Please use this section to upload Start and End Shifts.') }}</p>


                            <form [formGroup]="uploadGroup" cForm>


                                <div class="form-group row mb-2">
                                    <label class="col-sm-4 col-form-label text-end">{{ t('Identifier') }}</label>
                                    <div class="col-8">
                                    <select  class="form-control" id="identifier" name="identifier"   formControlName="identifier">
                                        <option value="pin">{{ t('PIN') }}</option>
                                        <option value="email">{{ t('Email') }}</option>
                                    </select>
                                    </div>
                                </div>



                                <div class="row mb-1">
                                    <div class="col">
                                    <input type="checkbox" class="form-check-input" formControlName="headers" name="headers"  id="headers">
                                    <label class="form-check-label" for="headers">&nbsp;{{ t('Headers are in the first row') }}</label>
                                    </div>
                                </div>

                                <c-row>
                                    <c-col class="mb-3 mt-2">
                                      <button cButton class="text-white btn-info" type="submit" (click)="continueUpload()" data-bs-toggle="modal" data-bs-target="#uploadModal">
                                        <i class="fa-solid fa-upload"></i> {{ t('Select Upload file and Continue') }}
                                      </button>
                                    </c-col>
                                  </c-row>


                            </form>

                        </div>
                      </div>


                      <div class="card mt-2">
                        <div class="card-header">
                            <i class="fa-solid fa-circle-question"></i> {{ t('How to Upload Start and End Shifts') }}
                        </div>
                        <div class="card-body">
                            <p>{{ t('You can now upload a csv or excel file with start and end shifts for multiple workers.') }}</p>
                            <ul>
                                <li>{{ t('Export from your scheduling software and easily import into OK Alone') }}</li>
                                <li>{{ t('Use an email or PIN to identify the worker') }}</li>
                                <li>{{ t('Add many start/end shift time for multiple workers') }} </li>
                                <li>{{ t('Add any shifts up to 1 year in the future') }} </li>
                            </ul>

                            <p><b>{{ t('What format should my file be in?') }}</b></p>
                            <p>{{ t('Your file needs to have 5 columns in the following order:') }}</p>
                            <ol>
                                <li><b>{{ t('Worker Email or PIN') }}</b> - {{ t('used to identify them') }}</li>
                                <li><b>{{ t('Worker Name') }}</b> - {{ t('reference only') }}</li>
                                <li><b>{{ t('Shift Date') }}</b></li>
                                <li><b>{{ t('Shift Start Time') }}</b> - {{ t("leave blank if there isn't one") }}</li>
                                <li><b>{{ t('Shift End Time') }}</b> - {{ t("leave blank if there isn't one") }}</li>
                            </ol>

                            <img src="/assets/images/shift-upload-example.jpg" alt="Shift Upload Example" class="img-fluid">
                            <br/>
                            <p> {{ t('Download an example file:') }}</p>
                            <ul>
                            <li><a href="/assets/files/ShiftUploadEmail.csv">{{ t('Download an Email Example') }}</a></li>
                            <li><a href="/assets/files/ShiftUploadPin.csv">{{ t('Download a PIN Example') }}</a></li>
                            </ul>



                        </div>
                      </div>

                </div>
                <div class="col-12 col-md-6">

                    <div class="card">
                        <div class="card-header">
                            <i class="fa-solid fa-download"></i> {{ t('Export Start and End Shifts') }}
                        </div>
                        <div class="card-body">
                            {{ t('Please use this form to export a calendar with the listed Start and End shifts. You can also use this export as a template which you can then edit and upload to update the shift times.') }}

                            <div class="row mb- row mb-2">
                                <label class="col-sm-4 col-form-label text-end">{{ t('Dates') }}</label>
                                <div class="col-sm-8">
                                    <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="export_dates" name="dates"  class="form-control"/>
                                </div>
                            </div>

                            <form [formGroup]="exportGroup" cForm>

                                <ng-container  *ngIf="okService.groups.length > 0">

                                    <div class="form-group row mb-2" >
                                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilGrain"></svg> {{ t('Groups') }}</label>
                                      <div class="col-8">

                                        <ng-select [items]="okService.groups"
                                                  bindLabel="name"
                                                  bindValue="id"
                                                  [multiple]="true"
                                                  formControlName="group_ids">
                                        </ng-select>
                                      </div>
                                    </div>

                                </ng-container>


                                <div class="form-group row mb-2" >
                                <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Workers') }}</label>
                                <div class="col-8">

                                    <ng-select [items]="okService.workers"
                                            bindLabel="name"
                                            bindValue="id"
                                            [multiple]="true"
                                            formControlName="worker_ids">
                                    </ng-select>

                                </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label class="col-sm-4 col-form-label text-end">{{ t('Identifier') }}</label>
                                    <div class="col-8">
                                    <select  class="form-control" id="identifier" name="identifier"   formControlName="identifier">
                                        <option value="pin">{{ t('PIN') }}</option>
                                        <option value="email">{{ t('Email') }}</option>
                                    </select>
                                    </div>
                                </div>

                                <c-row>
                                    <c-col class="mb-3 mt-2">
                                      <button cButton class="text-white btn-info" type="submit" (click)="submitExport()" [disabled]="export_loading">
                                        <div *ngIf="!export_loading"><i class="fa-solid fa-download"></i> {{ t('Export Start and End Shifts') }}  </div>
                                        <div *ngIf="export_loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Export Start and End Shifts') }}   </div>
                                      </button>
                                    </c-col>
                                  </c-row>


                            </form>
                        </div>
                    </div>


                  <div class="card mt-2">
                    <div class="card-header">
                        <i class="fa-solid fa-circle-question"></i> {{ t('How to Export Start and End Shifts') }}
                    </div>
                    <div class="card-body">
                        <p>{{ t('Export Start and End Shifts, edit the file, then upload, updating Start and End Shifts') }}</p>

                        <p><b>{{ t('What type of file does it export to?') }}</b></p>
                        <ol>
                            <li>{{ t('Excel File') }} - .xlsx</li>
                        </ol>

                        <p><b>{{ t('Information:') }}</b></p>
                        <ol>
                            <li>{{ t('If you choose email, and a worker does not have an email, they will be excluded from the export') }}</li>
                            <li>{{ t('Pull a report for your records') }}</li>
                            <li>{{ t('Filter by one Worker, multiple Workers, or at a Group level') }}</li>
                        </ol>


                    </div>
                  </div>

                </div>
            </div>
<style>
    .my-drop-zone { border: dotted 3px lightgray; }
    .nv-file-over { border: dotted 3px red; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }
</style>
    <!-- Modal -->
    <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">{{ t('Upload Start and End Shifts') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <ng-container *ngIf="upload_step==1">


                <div class="row">

                    <div class=" col-12 col-md-6">

                        <h3>{{ t('Select file') }}</h3>

                        <div ng2FileDrop
                             [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                             (fileOver)="fileOverBase($event)"
                             [uploader]="uploader"
                             class="well my-drop-zone"
                             style="width:100%;height:200px;">
                            {{ t('Drop you shift upload file here or select it using the button below') }}
                        </div>
                        <input type="file" ng2FileSelect [uploader]="uploader" />
                    </div>

                    <div class="col-12 col-md-6" style="margin-bottom: 40px">

                        <h3>{{ t('Upload queue') }}</h3>
                        <p>{{ t('Queue length') }}: {{ uploader?.queue?.length }}</p>

                        <table class="table">
                            <thead>
                            <tr>
                                <th width="50%">{{ t('Name') }}</th>
                                <th>{{ t('Size') }}</th>
                                <th>{{ t('Progress') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of uploader.queue">
                                <td><strong>{{ item?.file?.name }}</strong></td>
                                <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                                <td *ngIf="uploader.options.isHTML5">
                                    <div class="progress" style="margin-bottom: 0;">
                                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <ng-container *ngFor="let item of uploader.queue">

                            <button type="button" class="btn btn-success btn-xs"
                            (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                <span class="glyphicon glyphicon-upload"></span> {{ t('Upload') }}
                            </button>
                            <button type="button" class="btn btn-warning btn-xs"
                                    (click)="item.cancel()" [disabled]="!item.isUploading">
                                <span class="glyphicon glyphicon-ban-circle"></span> {{ t('Cancel') }}
                            </button>
                            <button type="button" class="btn btn-danger btn-xs"
                                    (click)="item.remove()">
                                <span class="glyphicon glyphicon-trash"></span> {{ t('Remove') }}
                            </button>
                        </ng-container>

                        <div>
                            <div>
                                {{ t('Queue progress') }}:
                                <div class="progress" style="">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                                </div>
                            </div>
                            <div class="alert alert-danger" role="alert"  *ngIf="file_error">
                              {{file_error}}
                            </div>
                        </div>

                    </div>

                </div>
                </ng-container>

                <ng-container *ngIf="upload_step==2">
                    <h3>{{ t('Here are all the shifts that have been updated') }}</h3>



                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{{ t('Worker') }}</th>
                                <th>{{ t('Date') }}</th>
                                <th>{{ t('Start Time') }}</th>
                                <th>{{ t('End Time') }}</th>
                                <th>{{ t('Notes') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let data of upload_data"  >


                                <tr [ngClass]="data['valid'] ? 'table-success' : 'table-warning'">
                                    <ng-container *ngIf="data['valid']">
                                        <td>
                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                        </td>
                                        <td>{{ data['worker_name']}}</td>
                                    </ng-container>
                                    <ng-container *ngIf="!data['valid']">
                                        <td>
                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                        </td>
                                        <td>{{ data['id'] }}</td>
                                    </ng-container>
                                    <td>{{ data['date_str'] }}</td>
                                    <td>{{ data['start_str'] }}</td>
                                    <td>{{ data['end_str'] }}</td>
                                    <td>{{ data['error'] }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                        </table>

                </ng-container>



            </div>
        </div>
        </div>
    </div>

    </c-card-body>
  </c-card>

